import { getMediaType } from "@/util/media";
import { SectionsHero, SectionProps } from "@/types";

import { heroVariant } from "./hero.variants";

export type UseHeroProps = SectionProps<SectionsHero>;

export const useHero = (props: UseHeroProps) => {
  const {
    className = "",
    data: { media, ...restData },
    sectionName,
  } = props;

  const styles = heroVariant();

  const isVideoBackground = !!media && getMediaType(media?.url) === "video";

  return {
    className,
    styles,
    isVideoBackground,
    data: { media, ...restData },
    sectionName,
  };
};
